import { message } from "antd";
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import { MessageTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles

export const MessageManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    body: "",
    paymentDueDate: 0,
    product: null,
    recipientType: "",
    sendDate: "",
    status: "SENT",
    timeofLastActivity: 0,
    title: "",
    selectRecipientBy: "",
    messageType: "",
    topic: "",
  });
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [messages, setMessages] = useState([]);
  const [editId, setEditId] = useState();
  const [modal, setModal] = useState({ add: false, edit: false, view: false });
  const [selectedFilter, setSelectedFilter] = useState("");
  const [products, setProducts] = useState([]);
  const [details, setDetails] = useState({});
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllMessages();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm], // Only call effect if debounced search term changes
  );

  const customerTypeOptions = [
    { label: "Individual", value: "BY_INDIVIDUAL_USER" },
    { label: "Corporate", value: "BY_CORPORATE_USER" },
  ];

  const dateOptions = [
    { label: "7 Days", value: 7 },
    { label: "14 Days", value: 14 },
    { label: "30 Days", value: 30 },
    { label: "Above 30 Days", value: 30 },
  ];

  const PUSH_MESSAGE_CHAR_LIMIT = 160;

  const showErrorMessage = (msg) => {
    message.error({
      content: msg || "Something went wrong. Please try again.",
      duration: 5,
    });
  };

  const getPlainTextLength = (htmlText) => {
    const div = document.createElement("div");
    div.innerHTML = htmlText;
    return div.textContent.length;
  };

  const stripHtmlTags = (htmlText) => {
    const div = document.createElement("div");
    div.innerHTML = htmlText;
    return div.textContent || div.innerText || "";
  };

  const filtersEnum = {
    byCustomerType: "BY_CUSTOMER_TYPE",
    byProductType: "BY_PRODUCT_TYPE_USER",
    byPaymentDue: "BY_PAYMENT_DUE",
    // byInvestmentMaturity: "BY_INVESTMENT_MATURITY",
    byTimeOfLastActivity: "BY_TIME_OF_LAST_ACTIVITY",
    byNoRunningInvestment: "BY_NO_RUNNING_INVESTMENT",
  };

  const filterOptions = [
    { label: "By Customer Type", value: filtersEnum.byCustomerType },
    { label: "By Product Type", value: filtersEnum.byProductType },
    { label: "By Payment Due", value: filtersEnum.byPaymentDue },
    // { label: "By Investment Maturity", value: filtersEnum.byInvestmentMaturity },
    { label: "By Time Of Last Activity", value: filtersEnum.byTimeOfLastActivity },
    { label: "By No Running Investment", value: filtersEnum.byNoRunningInvestment },
  ];

  const handleSelectChange = (e) => {
    setSelectedFilter(e.value);
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // If messageType is changed to Push, set recipientType to BY_INDIVIDUAL_USER
    // if (name === "messageType" && value === "Push") {
    //   setFormData({ ...formData, [name]: value, recipientType: "BY_INDIVIDUAL_USER" });
    // } else {
    //   setFormData({ ...formData, [name]: value });
    // }
  };

  const handleSelecteFieldChange = (e, name) => {
    setFormData({ ...formData, [name]: e.value });
  };

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;

      if (resultData) {
        setProducts(resultData.filter(({ status }) => status === "ACTIVE"));
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onEditClick = async (item) => {
    setModal({ edit: true });
    setFormData({
      body: item?.body,
      paymentDueDate: item?.paymentDueDate,
      product: item?.product,
      recipientType: item?.recipientType,
      sendDate: item?.sendDate,
      status: item?.status,
      timeofLastActivity: item?.timeofLastActivity,
      title: item?.title,
      selectRecipientBy: item?.selectRecipientBy,
      messageType: item?.messageType || (item?.channel === "EMAIL" ? "Email" : "Push"),
      channel: item?.channel,
      topic: item?.topic,
    });
    setEditId(item.id);
  };

  const getAllMessages = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/message-centre?platform=TREASURY&search=${search}`,
        {
          headers: authHeader(),
        },
      );
      const { data } = response;
      if (data) {
        setMessages(data.data.body);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const resolveRecipientType = (obj) => {
    if (formData?.selectRecipientBy === "customer_id") {
      return "BY_INDIVIDUAL_USER";
    }

    if (obj?.messageType === "Email") {
      return obj?.recipientType ? obj.recipientType : null;
    }

    return obj?.recipientType ? obj.recipientType : selectedFilter || null;
  };

  const createMessage = async (obj) => {
    try {
      setIsLoadBtn(true);
      const messageBody = obj.messageType === "Push" ? stripHtmlTags(obj.body) : obj.body;
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/message-centre`,
        {
          body: messageBody,
          paymentDueDate: obj.paymentDueDate,
          sendDate: obj.sendDate,
          status: obj.status,
          timeofLastActivity: obj.timeofLastActivity,
          title: obj.title,
          channel: obj.messageType === "Email" ? "EMAIL" : "PUSH",
          topic:
            obj.messageType === "Push"
              ? obj.recipientType === "BY_INDIVIDUAL_USER"
                ? "individuals"
                : obj.recipientType === "BY_CORPORATE_USER"
                  ? "companies"
                  : "default"
              : null,
          messageType: obj.messageType,
          product: obj?.product ? obj?.product : null,
          recipientType: resolveRecipientType(obj),
          platform: "TREASURY",
          recipient: obj?.customerId ? [Number(obj?.customerId)] : null,
        },
        {
          headers: authHeader(),
        },
      );
      const res = await response.data;
      if (res) {
        getAllMessages();
        message.success({
          content: `Message ${
            obj.status === "SENT"
              ? "sent"
              : obj.status === "PENDING" && obj.sendDate
                ? `scheduled to be delivered on ${obj.sendDate}`
                : "saved to Draft"
          }`,
        });
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        resetForm();
      }
    } catch (error) {
      showErrorMessage(error?.response?.data?.message || error?.message || "Unable to send message.");
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      return { message };
    } finally {
      setIsLoadBtn(false);
    }
  };
  const editMessage = async (obj) => {
    try {
      setIsLoadBtn(true);
      const messageBody = obj.messageType === "Push" ? stripHtmlTags(obj.body) : obj.body;
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/message-centre/${editId}`,
        {
          ...obj,
          body: messageBody,
          topic:
            obj.messageType === "Push"
              ? obj.recipientType === "BY_INDIVIDUAL_USER"
                ? "individuals"
                : obj.recipientType === "BY_CORPORATE_USER"
                  ? "companies"
                  : null
              : null,
          recipientType: resolveRecipientType(obj),
        },
        {
          headers: authHeader(),
        },
      );
      const formData = await response.data;
      if (formData) {
        getAllMessages();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success({
          content: `Message ${
            obj.status === "SENT"
              ? "sent"
              : obj.status === "PENDING" && obj.sendDate
                ? `scheduled to be delivered on ${obj.sendDate}`
                : "saved to Draft"
          }`,
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      showErrorMessage(error?.response?.data?.message || error?.message || "Unable to update message.");
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      resetForm();
      return { error };
    }
  };
  const deleteMessage = async (id) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/admin/message-centre/${id}`, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllMessages();
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: `Message Deleted Successfully!`,
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      showErrorMessage(error?.response?.data?.message || error?.message || "Unable to delete message.");
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      return { error };
    }
  };

  const hasRecipientSelected = () => {
    if (formData?.messageType === "Email") {
      return true;
    }

    return formData?.selectRecipientBy === "customer_id"
      ? !!formData?.customerId
      : !!(formData?.recipientType || selectedFilter);
  };

  const onFormSubmit = () => {
    // Check character limit for Push messages
    if (formData?.messageType === "Push" && getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT) {
      showErrorMessage(`Push message exceeds the ${PUSH_MESSAGE_CHAR_LIMIT} character limit`);
      return;
    }
    if (!hasRecipientSelected()) {
      showErrorMessage("Please select a recipient before sending");
      return;
    }
    createMessage(formData);
  };

  const onEditSubmit = () => {
    // Check character limit for Push messages
    if (formData?.messageType === "Push" && getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT) {
      showErrorMessage(`Push message exceeds the ${PUSH_MESSAGE_CHAR_LIMIT} character limit`);
      return;
    }
    editMessage(formData);
  };

  const resetForm = () => {
    setFormData({
      body: "",
      paymentDueDate: 0,
      product: null,
      recipientType: "",
      sendDate: "",
      status: "SENT",
      timeofLastActivity: 0,
      title: "",
      selectRecipientBy: "",
      messageType: "",
      topic: "",
    });
  };

  useEffect(() => {
    getAllMessages();
    getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = messages?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const { errors, register, handleSubmit } = useForm();

  const productOptions =
    products?.map((prod, _idx) => ({
      label: prod?.productName,
      value: prod?.id,
    })) ?? [];

  const onViewClick = (item) => {
    setDetails(item);
    setModal((prev) => ({ ...prev, view: true }));
  };

  const handleChange = (value) => {
    setFormData({ ...formData, body: value });
    // console.log("quill texting", value);
  };

  return (
    <React.Fragment>
      <Head title="Message Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Message Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Message..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_MESSAGE"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus" />
                      <span>Create Message</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <MessageTable
                data={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                onViewClick={onViewClick}
                handleDelete={deleteMessage}
              />
            )}
          </Card>
          <div className="card-inner">
            {messages && messages.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={messages.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Messages found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Create Message</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Message Title</label>
                      <input
                        type="text"
                        name="title"
                        placeholder="Message Title"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Message Type</label>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="email"
                            value="Email"
                            name="messageType"
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="email">
                            Email
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="push"
                            value="Push"
                            name="messageType"
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="push">
                            Push
                          </label>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">
                        Select Recipient By
                        {/* {formData?.messageType === "Push" ? "Select Recipient" : "Select Recipient By"} */}
                      </label>

                      <div style={{ display: "flex", gap: "20px" }}>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="customerId"
                            value="customer_id"
                            name="selectRecipientBy"
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="customerId">
                            By Customer Id
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="filter"
                            value="filter"
                            onChange={(e) => onInputChange(e)}
                            name="selectRecipientBy"
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="filter">
                            Filter
                          </label>
                        </div>
                      </div>
                      {/* )} */}
                    </FormGroup>
                  </Col>
                  {formData.selectRecipientBy === "customer_id" && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">Customer ID</label>
                        <input
                          type="text"
                          name="customerId"
                          placeholder="Enter Customer ID"
                          onChange={(e) => onInputChange(e)}
                          className="form-control"
                        />
                        {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">Select Filter</label>
                        <RSelect options={filterOptions} onChange={(e) => handleSelectChange(e)} />
                        {/* {errors.customerId && <span className="invalid">{errors.customerId.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byCustomerType && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Customer Type</label>
                        <RSelect
                          options={customerTypeOptions}
                          name="recipientType"
                          onChange={(e) => handleSelecteFieldChange(e, "recipientType")}
                          value={customerTypeOptions.filter(({ value }) => formData?.recipientType === value)[0]}
                        />
                        {errors.recipientType && <span className="invalid">{errors.recipientType.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byProductType && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Product Type</label>
                        <RSelect
                          name="product"
                          options={productOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "product")}
                          value={productOptions.filter(({ value }) => formData?.product === value)[0]}
                        />
                        {errors.product && <span className="invalid">{errors.product.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byPaymentDue && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Payment Due Date</label>
                        <RSelect
                          name="paymentDueDate"
                          options={dateOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "paymentDueDate")}
                          value={dateOptions.filter(({ value }) => formData?.paymentDueDate === value)[0]}
                        />
                        {errors.paymentDueDate && <span className="invalid">{errors.paymentDueDate.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byTimeOfLastActivity && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Time of Last Activity</label>
                        <RSelect
                          name="timeofLastActivity"
                          options={dateOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "timeofLastActivity")}
                          value={dateOptions.filter(({ value }) => formData?.timeofLastActivity === value)[0]}
                        />
                        {errors.timeofLastActivity && (
                          <span className="invalid">{errors.timeofLastActivity.message}</span>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Message Body</label>
                      {/* <textarea
                        name="body"
                        defaultValue={formData.message}
                        placeholder="Enter Message"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                      /> */}
                      <ReactQuill
                        value={formData?.body}
                        onChange={handleChange}
                        modules={{
                          toolbar: [
                            [{ header: "1" }, { header: "2" }],
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["link"],
                            ["clean"],
                          ],
                        }}
                      />
                      {formData?.messageType === "Push" && (
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginTop: "8px", fontSize: "0.875rem" }}
                        >
                          <span
                            style={{
                              color:
                                getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT ? "#dc3545" : "#6c757d",
                            }}
                          >
                            {getPlainTextLength(formData?.body)} / {PUSH_MESSAGE_CHAR_LIMIT} characters
                          </span>

                          {getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT && (
                            <span className="invalid text-danger text-end">You have exceeded the character limit</span>
                          )}
                        </div>
                      )}

                      {errors.body && <span className="invalid">{errors.body.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Schedule Send</label>
                      <select
                        className="form-control"
                        value={formData?.status}
                        name="status"
                        onChange={(e) => onInputChange(e)}
                      >
                        <option value="SENT">Send Now</option>
                        <option value="DRAFT">Save as Draft</option>
                        <option value="PENDING">Send Later</option>
                      </select>
                      {errors.schedule && <span className="invalid">{errors.schedule.message}</span>}
                    </FormGroup>
                  </Col>
                  {formData.status === "PENDING" && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Scheduled Date </label>
                        <input
                          type="date"
                          name="sendDate"
                          value={formData?.sendDate}
                          onChange={(e) => onInputChange(e)}
                          className="form-control"
                        />
                        {errors.sendDate && <span className="invalid">{errors.sendDate.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          disabled={
                            formData?.messageType === "Push" &&
                            getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT
                          }
                        >
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Message</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Message Title</label>
                      <input
                        type="text"
                        name="title"
                        value={formData?.title}
                        placeholder="Message Title"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Message Type</label>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="email"
                            value="Email"
                            name="messageType"
                            checked={formData?.messageType === "Email"}
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="email">
                            Email
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="push"
                            value="Push"
                            name="messageType"
                            checked={formData?.messageType === "Push"}
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="push">
                            Push
                          </label>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Select Recipient By</label>

                      <div style={{ display: "flex", gap: "20px" }}>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="customerId"
                            value="customer_id"
                            name="selectRecipientBy"
                            checked={formData?.selectRecipientBy === "customer_id"}
                            onChange={(e) => onInputChange(e)}
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="customerId">
                            By Customer Id
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-sm">
                          <input
                            type="radio"
                            id="filter"
                            value="filter"
                            checked={formData?.selectRecipientBy === "filter"}
                            onChange={(e) => onInputChange(e)}
                            name="selectRecipientBy"
                            className="custom-control-input form-control"
                          />
                          <label className="custom-control-label" htmlFor="filter">
                            Filter
                          </label>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                  {formData.selectRecipientBy === "customer_id" && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">Customer ID</label>
                        <input
                          type="text"
                          name="customerId"
                          placeholder="Enter Customer ID"
                          onChange={(e) => onInputChange(e)}
                          className="form-control"
                        />
                        {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">Select Filter</label>
                        <RSelect options={filterOptions} onChange={(e) => handleSelectChange(e)} />
                        {/* {errors.customerId && <span className="invalid">{errors.customerId.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byCustomerType && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Customer Type</label>
                        <RSelect
                          options={customerTypeOptions}
                          name="recipientType"
                          onChange={(e) => handleSelecteFieldChange(e, "recipientType")}
                          value={customerTypeOptions.filter(({ value }) => formData?.recipientType === value)[0]}
                        />
                        {errors.recipientType && <span className="invalid">{errors.recipientType.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byProductType && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Product Type</label>
                        <RSelect
                          name="product"
                          options={productOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "product")}
                          value={productOptions.filter(({ value }) => formData?.product === value)[0]}
                        />
                        {errors.product && <span className="invalid">{errors.product.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byPaymentDue && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Payment Due Date</label>
                        <RSelect
                          name="paymentDueDate"
                          options={dateOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "paymentDueDate")}
                          value={dateOptions.filter(({ value }) => formData?.paymentDueDate === value)[0]}
                        />
                        {errors.paymentDueDate && <span className="invalid">{errors.paymentDueDate.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byInvestmentMaturity && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">By Investment Maturity</label>
                        <RSelect
                          options={[]}
                          name="investmentMaturity"
                          onChange={(e) => handleSelecteFieldChange(e, "investmentMaturity")}
                          value={[].filter(({ value }) => formData?.investmentMaturity === value)[0]}
                        />
                        {errors.investmentMaturity && (
                          <span className="invalid">{errors.investmentMaturity.message}</span>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  {formData.selectRecipientBy === "filter" && selectedFilter === filtersEnum.byTimeOfLastActivity && (
                    <Col md="12">
                      <FormGroup>
                        <label className="form-label">Time of Last Activity</label>
                        <RSelect
                          name="timeofLastActivity"
                          options={dateOptions}
                          onChange={(e) => handleSelecteFieldChange(e, "timeofLastActivity")}
                          value={dateOptions.filter(({ value }) => formData?.timeofLastActivity === value)[0]}
                        />
                        {errors.timeofLastActivity && (
                          <span className="invalid">{errors.timeofLastActivity.message}</span>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Message Body</label>
                      {/* <textarea
                        name="body"
                        value={formData?.body}
                        defaultValue={formData.body}
                        placeholder="Enter Message"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                      /> */}
                      <ReactQuill
                        value={formData?.body}
                        onChange={handleChange}
                        modules={{
                          toolbar: [
                            [{ header: "1" }, { header: "2" }],
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["link"],
                            ["clean"],
                          ],
                        }}
                      />
                      {formData?.messageType === "Push" && (
                        <div style={{ marginTop: "8px", fontSize: "0.875rem" }}>
                          <span
                            style={{
                              color:
                                getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT ? "#dc3545" : "#6c757d",
                            }}
                          >
                            {getPlainTextLength(formData?.body)} / {PUSH_MESSAGE_CHAR_LIMIT} characters
                          </span>
                          {getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT && (
                            <div className="invalid" style={{ marginTop: "4px" }}>
                              Push message exceeds the {PUSH_MESSAGE_CHAR_LIMIT} character limit
                            </div>
                          )}
                        </div>
                      )}
                      {errors.body && <span className="invalid">{errors.body.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Schedule Send</label>
                      <select
                        className="form-control"
                        value={formData?.status}
                        name="status"
                        onChange={(e) => onInputChange(e)}
                      >
                        <option value="">Select Schedule</option>
                        <option value="SENT">Send Now</option>
                        <option value="DRAFT">Save as Draft</option>
                        <option value="PENDING">Send Later</option>
                      </select>
                      {errors.schedule && <span className="invalid">{errors.schedule.message}</span>}
                    </FormGroup>
                  </Col>
                  {formData.status === "PENDING" && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Scheduled Date </label>
                        <input
                          type="date"
                          name="sendDate"
                          value={formData?.sendDate}
                          onChange={(e) => onInputChange(e)}
                          className="form-control"
                        />
                        {errors.sendDate && <span className="invalid">{errors.sendDate.message}</span>}
                      </FormGroup>
                    </Col>
                  )}
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          disabled={
                            formData?.messageType === "Push" &&
                            getPlainTextLength(formData?.body) > PUSH_MESSAGE_CHAR_LIMIT
                          }
                        >
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Message Details</h5>
              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Date: </span>
                      <span>{details?.dateCreated}</span>
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Message Title: </span>
                      <span>{details?.title}</span>
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="12">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Body Of Message: </span>
                      <span dangerouslySetInnerHTML={{ __html: details?.body }} />
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between my-2 mt-5">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Recipient: </span>
                      {details?.recipient?.length >= 1 ? (
                        <span>
                          {details?.recipient?.map((recipient) => (
                            <p>{recipient?.email}</p>
                          ))}
                        </span>
                      ) : (
                        <>
                          {details?.planUsersRecipient?.length >= 1 ? (
                            <span>
                              {details?.planUsersRecipient?.map((recipient) => (
                                <p>{recipient?.email}</p>
                              ))}
                            </span>
                          ) : (
                            <>
                              {details?.investmentUsersRecipient?.length >= 1 ? (
                                <span>
                                  {details?.investmentUsersRecipient?.map((recipient) => (
                                    <p>{recipient?.email}</p>
                                  ))}
                                </span>
                              ) : (
                                <>
                                  {details?.companyUsersRecipient?.length >= 1 ? (
                                    <span>
                                      {details?.companyUsersRecipient?.map((recipient) => (
                                        <p>{recipient?.name}</p>
                                      ))}
                                    </span>
                                  ) : (
                                    <>
                                      {details?.individualUsersRecipient?.length >= 1 ? (
                                        <span>
                                          {details?.individualUsersRecipient?.map((recipient) => (
                                            <p>
                                              {recipient?.firstName} {recipient?.lastName}
                                            </p>
                                          ))}
                                        </span>
                                      ) : (
                                        <>
                                          {details?.paymentDueUser?.length >= 1 ? (
                                            <span>
                                              {details?.paymentDueUser?.map((recipient) => (
                                                <p>{recipient?.email}</p>
                                              ))}
                                            </span>
                                          ) : (
                                            <>
                                              {details?.usersWithNoRunningPlan?.length >= 1 ? (
                                                <span>
                                                  {details?.usersWithNoRunningPlan?.map((recipient) => (
                                                    <p>{recipient?.email}</p>
                                                  ))}
                                                </span>
                                              ) : (
                                                <>
                                                  {details?.usersWithLastLoginDate?.length >= 1 ? (
                                                    <span>
                                                      {details?.usersWithLastLoginDate?.map((recipient) => (
                                                        <p>{recipient?.email}</p>
                                                      ))}
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Status: </span>
                      <span className={`badge badge-dot badge-${details?.status === "SENT" ? "success" : "danger"}`}>
                        {details?.status}
                      </span>
                    </p>
                  </Col>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
